import { useState } from 'react'
import { LuCircleHelp } from 'react-icons/lu'

import { HelpModal } from '@/components/HelpModal/HelpModal'
import { AlertNavPopout } from '@/feature/alerts/components/AlertNavPopout'
import { FeatureFlag, WhenFlag } from '@/feature/feature-flags'
import { FormattedMessage } from 'react-intl'

import { UserAvatarLink } from './UserAvatarLink'
import messages from './TopbarMenu.messages'
import styles from './TopbarMenu.module.css'
import { HelpersContainer, HelpLink } from './TopbarMenu.styles'

export const TopbarMenu = () => {
  const [openHelpModal, setOpenHelpModal] = useState(false)

  return (
    <HelpersContainer>
      <FeatureFlag flag="featureUserpilotHelp">
        <WhenFlag>
          <button
            className={styles.helpButton}
            onClick={() => {
              setOpenHelpModal(true)
            }}
            type="button"
          >
            <LuCircleHelp size={20} />
            Help
          </button>
        </WhenFlag>
        <WhenFlag not>
          <HelpLink href="https://help.gometroapp.com/" target="_blank">
            <LuCircleHelp />
            <FormattedMessage {...messages.help} />
          </HelpLink>
        </WhenFlag>
      </FeatureFlag>
      <FeatureFlag flag="featureExecutionBoardUi">
        <WhenFlag>
          <AlertNavPopout />
        </WhenFlag>
      </FeatureFlag>
      <UserAvatarLink />
      <HelpModal
        isActive={openHelpModal}
        onClose={() => {
          setOpenHelpModal(false)
        }}
      />
    </HelpersContainer>
  )
}
